/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PagerView.vue?vue&type=template&id=6094a4e4&scoped=true"
import script from "./PagerView.vue?vue&type=script&lang=js"
export * from "./PagerView.vue?vue&type=script&lang=js"
import style0 from "./PagerView.vue?vue&type=style&index=0&id=6094a4e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094a4e4",
  null
  
)

export default component.exports